import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { config } from '@/config';

/** One account this browser is signed in to (docs/MultiAccountSessions.md §5). */
export interface HeldAccount {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  /** False once it was signed out elsewhere (a password reset, a sign-out on another device). */
  signedIn: boolean;
}

export const HELD_ACCOUNTS_KEY = ['heldAccounts'] as const;

/** The accounts this browser holds, in the order it holds them. */
export function useHeldAccounts(enabled = true) {
  return useQuery<HeldAccount[]>({
    queryKey: HELD_ACCOUNTS_KEY,
    queryFn: async () => {
      const { data } = await axios.get<HeldAccount[]>(`${config.backendApi}/api/auth/accounts`, {
        withCredentials: true,
      });
      return Array.isArray(data) ? data : [];
    },
    enabled,
    staleTime: 30_000,
  });
}
